export default __webpack_public_path__ + "static/media/us-fl.12a267ba.svg";